export enum ErrorCodes {
  InternalError = 500,
  success = 200,
  UnAuthorized = 401,
}

export enum ErrorTypes {
  Unhandled = "unhandled",
  Validation = "validation",
}

// features and associated entities
export const Features = {
  Accounts: { specialPermissions: ["Read", "Create", "Update"] },
  Requests: { specialPermissions: ["Read"] },
  Campaigns: { specialPermissions: ["Read", "Update"], Read: ["Accounts"] },
  "Ad Groups": { Read: ["Accounts", "Campaigns"] },
  "Hotel Groups": {
    specialPermissions: ["Read"],
    Read: ["Accounts", "Campaigns", "Ad Groups"],
  },
  Devices: { specialPermissions: ["Read"], Read: ["Accounts"] },
  "Shared Budgets": { Read: ["Accounts"] },
  "Hotel Callouts": { specialPermissions: ["Read"], Read: ["Accounts"] },
  "Hotel Assets": {
    specialPermissions: ["Read"],
    Read: ["Accounts", "Campaigns", "Ad Groups"],
  },
  Users: { Write: ["Roles"] },
  Roles: {},
  Rules: { Write: ["Accounts", "Campaigns", "Ad Groups", "Hotel Groups"] },
};

export const operators: any = {
  eq: { name: "=", type: ["string", "number", "date", "boolean"] },
  ne: { name: "!=", type: ["string", "number", "date", "boolean"] },
  lt: { name: "<", type: ["number", "date"] },
  lte: { name: "<=", type: ["number", "date"] },
  gt: { name: ">", type: ["number", "date"] },
  gte: { name: ">=", type: ["number", "date"] },
  like: { name: "Like", type: ["string"] },
  in: { name: "In", type: ["boolean"] },
  notIn: { name: "Not In", type: ["boolean"] },
  // startsWith: { name: "Start With", type: ["string"] },
  // endsWith: { name: "Ends With", type: ["string"] },
};

export enum paymentType {
  Advance = "Advance",
  Monthly = "Monthly",
}

export enum PaymentStatus {
  failed = "failed",
  success = "success",
}

export enum serviceType {
  service = "service",
  addOnService = "addOnService",
}

export enum MaximumFileSize {
  twoMb = 2097152, //2 * 1024 * 1024
}
export enum Gender {
  Male = "Male",
  Female = "Female",
  Other = "Other",
}
export enum EmployeeType {
  Admin = "Admin",
  Employee = "Employee",
  Transport = "Transport Team",
  Security = "Security Manager",
}

export enum UserType {
  SuperAdmin = "SuperAdmin",
  Admin = "Admin",
  Member = "Member",
  Employee = "Employee",
  TeamLead = "Team Lead",
  Transportation = "Transport Team",
}
export enum BloodGroup {
  "A+" = "A+",
  "B+" = "B+",
  "B-" = "B-",
  "AB+" = "AB+",
  "AB-" = "AB-",
  "O+" = "O+",
  "O-" = "O-",
}
export enum SpecialConsideration {
  Yes = "Yes",
  No = "No",
}

export enum Status {
  Active = "Active",
  Inactive = "Inactive",
  Approved = "Approved",
  Rejected = "Rejected",
  Requested = "Requested",
  Cancelled = "Cancelled",
  EmployeeSelfNoShow = "Employee-Self-No-Show",
}

export enum RequestStatus {
  Pending = "Pending",
  Approved = "Approved",
  Cancelled = "Cancelled",
  Rejected = "Rejected",
  Invited = "Invited",
}
export const BillingPlans = {
  PerKMBilling: "Per KM Billing",
  PerTripSlabBilling: "Per Trip & Slab Billing",
  PerTripMultiSlabBilling: "Per Trip Multi-Slab Billing",
};
export enum TripStatus {
  Active = "Active",
  Inactive = "Inactive",
  Requested = "Requested",
  Rejected = "Rejected",
}


export enum TripType {
  Pick = "Pick",
  Drop = "Drop"
}
